import { useFormContext } from 'rhf-v7';
import { ICvvRequirementInfo } from 'obt-common';
import { getIsCvvRequiredForPaymentSourceId } from 'obt-common/utils/payment/getIsCvvRequiredForPaymentSourceId';
import useAllPaymentSetupResponse from './useAllPaymentSetupResponse';
import { RetryPaymentCheckoutFormValues } from '../FormProvider/types';

export interface IUseIsCvvRequired {
  cvvRequirement: ICvvRequirementInfo;
}

export const useIsCvvRequired = (): IUseIsCvvRequired => {
  const { watch } = useFormContext<RetryPaymentCheckoutFormValues>();
  const paymentSourceIds = watch('selectedPaymentSourceIds');

  const selectedPaymentSourceId = paymentSourceIds[0];

  const allPaymentSetupResponse = useAllPaymentSetupResponse();

  const cvvRequirement = getIsCvvRequiredForPaymentSourceId(selectedPaymentSourceId, allPaymentSetupResponse);

  return {
    cvvRequirement,
  };
};
